import React, { useState } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Column, Row } from 'simple-flexbox';
import { SidebarComponent, SidebarContext } from 'components/sidebar';
import HeaderComponent from 'components/header/HeaderComponent';
import PrivateRoutes from './PrivateRoutes';

const useStyles = createUseStyles({
    container: {
        height: '100%',
        minHeight: '100vh',
        // background: 'linear-gradient(135deg, #085d40 0%, #077E55 50%, #14b576 100%)'
        // background: '#085d40'
        background: 'white'
    },
    mainBlock: ({ sidebarCollapsed }) => ({
        marginLeft: sidebarCollapsed ? 80 : 255,
        padding: 30,
        transition: 'margin-left 0.3s ease',
        '@media (max-width: 1080px)': {
            marginLeft: 0
        }
    }),
    contentBlock: {
        marginTop: 54
    }
});

function PrivateSection() {
    const theme = useTheme();
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const classes = useStyles({ theme, sidebarCollapsed });

    const toggleSidebar = () => {
        setSidebarCollapsed(!sidebarCollapsed);
    };

    return (
        <SidebarContext>
            <Row className={classes.container}>
                <SidebarComponent collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
                <Column flexGrow={1} className={classes.mainBlock}>
                    <HeaderComponent />
                    <div className={classes.contentBlock}>
                        <PrivateRoutes />
                    </div>
                </Column>
            </Row>
        </SidebarContext>
    );
}

export default PrivateSection;
